"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    sihuaLu: '禄',
    sihuaQuan: '权',
    sihuaKe: '科',
    sihuaJi: '忌',
};
